import React, { useState } from "react";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader, Checkbox } from "kubra-ux-forge";
import { COMMON_NAMESPACE } from "constants/i18n-namespaces";
import { useTranslation } from "react-i18next";
export interface SandboxWarningModalProps {
  open: boolean;
  closeSandbox: () => void;
  dataCy?: string;
}

export const getCookieValue = (name: string): string | false => {
  if (typeof document === "undefined") {
    return false;
  }

  const cookie = document.cookie
    .split("; ")
    .find((entry) => entry.startsWith(`${name}=`));

  if (!cookie) {
    return false;
  }

  return decodeURIComponent(cookie.substring(name.length + 1));
};

export const SandboxWarningModal = ({
  open,
  closeSandbox,
  dataCy = "sandbox-warning-modal",
}: SandboxWarningModalProps) => {
  const [dontShowAgain, setDontShowAgain] = useState<boolean>(() => {
    const cookieValue = getCookieValue("dontshowSandboxWarning");
    return cookieValue !== false && cookieValue.toLowerCase() === "true";
  });

  const { t } = useTranslation(COMMON_NAMESPACE);

  const onClose = () => {
    if (dontShowAgain) {
      const expiryDate = new Date();
      expiryDate.setDate(expiryDate.getDate() + 30);
      document.cookie = `dontshowSandboxWarning=true; expires=${expiryDate.toUTCString()}; path=/`;
    }
    closeSandbox();
  };
  
  return (
    <div className="sandbox-warning-modal-container">
      <Modal
        open={open}
        sharpCorners={true}
        onBackdropClick={onClose}
        dataCy={dataCy}
      >
        <ModalHeader
          className="modal-header-text-container"
          onClose={onClose}
          showCloseButton>
          {t("sandboxWarningModalTitle")}
        </ModalHeader>
        <ModalBody className="sandbox-warning-modal-body">
          <div
            className="sandbox-warning-modal-message"
            data-cy={`${dataCy}-message`}
          >
            {t("sandboxWarningModalDesc")}
          </div>
          <Checkbox
            className="sandbox-warning-modal-checkbox"
            label={t("sandboxWarningModalCheckbox")}
            defaultChecked={dontShowAgain}
            onChange={() => setDontShowAgain((previous) => !previous)}
            variant="simple"
          />
        </ModalBody>
        <ModalFooter>
          <div className="sandbox-warning-modal-actions">
            <Button onClick={onClose} dataCy={`${dataCy}-close-button`}>
              {t("sandboxWarningModalContinue")}
            </Button>
          </div>
        </ModalFooter>
      </Modal>
    </div>
  );
};

export default SandboxWarningModal;
